import { FC, SVGProps } from "react";

const Plus: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M30.5 14.5H17.5V1.5C17.5 0.672 16.828 0 16 0C15.172 0 14.5 0.672 14.5 1.5V14.5H1.5C0.672 14.5 0 15.172 0 16C0 16.828 0.672 17.5 1.5 17.5H14.5V30.5C14.5 31.328 15.172 32 16 32C16.828 32 17.5 31.328 17.5 30.5V17.5H30.5C31.328 17.5 32 16.828 32 16C32 15.172 31.328 14.5 30.5 14.5Z"
        fill="white"
      />
    </svg>
  );
};

export default Plus;
